import alert from '@/plugins/alert'
import { Facility } from '@/plugins/api'
import axios from '@/plugins/axios'
const UPLOAD_API = '/upload/'
const DESTROY_API = '/upload/files/'
export default {
  namespaced: true,
  state: {
    facility: {},
    count: 0,
    imgs: []
  },
  actions: {
    async uploadImgs({ commit }, formData) {
      try {
        const response = await axios.post(UPLOAD_API, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        commit('setImgs', response)
        alert.success('Upload successfully!')
      } catch (e) {
        alert.error(e)
      }
    },
    async fetchFacility({ commit }, facilityId) {
      const facility = await Facility.fetchOne(facilityId)
      commit('setFacility', facility)
      commit('setImgs', facility.imgs)
    },
    async createFacility({ commit }, { data, options }) {
      commit('setFacility', await Facility.create(data, options))
      alert.success('Cập nhật thành công!')
    },
    async updateFacility({ commit, state }, { id, ...facility }) {
      commit('setFacility', await Facility.update(id, facility))
      alert.success('Cập nhật thành công!')
    },
    setFacility({ commit, state }, facility) {
      commit('setFacility', facility)
    },
    destroyImage({ commit }, id) {
      commit('setLoading', true)
      return axios
        .delete(DESTROY_API + id)
        .then(data => {
          commit('removeImg', id)
          alert.success('Xóa thành công!')
        })
        .catch(e => alert.error(e))
    }
  },
  mutations: {
    setFacility(state, facility) {
      state.facility = facility
    },
    setImgs(state, imgs) {
      state.imgs = [...imgs, ...state.imgs]
    },
    removeImg(state, id) {
      state.student = {
        ...state.student,
        imgs: state.student.imgs.filter(i => i.id !== id)
      }
    }
  },
  getters: {
    facility: state => {
      return state.facility
    },
    imgs: state => {
      return state.imgs
    },
    count: state => {
      return state.count
    }
  }
}
